import { Text } from '@mantine/core'
import React from 'react'

export function CollapsibleCardDescription({
  children,
}: React.PropsWithChildren) {
  return <Text color='dimmed'>{children}</Text>
}

CollapsibleCardDescription.displayName = 'CollapsibleCard.Description'
